// React application entry point for Academician Startup
// This is bundled by esbuild and included via javascript_include_tag
import "./react-mount";
import { createConsumer } from "@rails/actioncable";

// Make ActionCable consumer globally available for inline scripts
const consumer = createConsumer();
(window as any).ActionCable = { createConsumer: () => consumer };

// Auto-submit forms when a file input with data-auto-submit changes
document.addEventListener("change", (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (target.matches('input[type="file"][data-auto-submit]')) {
    target.closest("form")?.requestSubmit();
  }
});

